import apiClient from "./apiClient";
import { SubscriptionTypeResponse, SubscriptionTypeUpsertRequest } from "../../types/types";
import { API_ENDPOINTS } from "../../utils/config/constants";

export const SubscriptionTypesApi = {
  getAll: async () => {
    const response = await apiClient.get<SubscriptionTypeResponse[]>(API_ENDPOINTS.SUBSCRIPTION_TYPES);
    return response.data;
  },
  create: async (payload: SubscriptionTypeUpsertRequest) => {
    const response = await apiClient.post<SubscriptionTypeResponse>(API_ENDPOINTS.SUBSCRIPTION_TYPES, payload);
    return response.data;
  },
  update: async (id: number, payload: SubscriptionTypeUpsertRequest) => {
    const response = await apiClient.put<SubscriptionTypeResponse>(`${API_ENDPOINTS.SUBSCRIPTION_TYPES}/${id}`, payload);
    return response.data;
  },
};
